// extracted by mini-css-extract-plugin
module.exports = {"msg":"provider-form_msg_LkafM","subicon":"provider-form_subicon_1rC5l"};